import { mapActions } from 'vuex'

import Background from '@/components/sidenav/shared/Background'
import Alignment from '@/components/sidenav/shared/Alignment'
import SelfAlignment from '@/components/sidenav/shared/SelfAlignment'
import Spacement from '@/components/sidenav/shared/Spacement'
import Collapsible from '@/shared/components/Collapsible'
import Divider from '@/shared/components/Divider'
import Style from '@/shared/components/Style'
import Toggle from '@/shared/components/Toggle'
import Input from '@/shared/components/Input'
import Button from '@/shared/components/Button'
import ColorPicker from '@/shared/components/ColorPicker'

import { fromScssToCss } from '@/helpers/filtersHelper.js'

export default {
  components: {
    Background,
    Spacement,
    SelfAlignment,
    Alignment,
    Collapsible,
    Style,
    Toggle,
    Divider,
    Input,
    Button,
    ColorPicker,
  },
  props: {
    id: {
      type: String,
      default: '',
    },
    currentView: {
      type: String,
      default: '',
    },
    options: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  methods: {
    ...mapActions('landing', ['updateOptions', 'batchRemove']),
    async styleChanged(prefix, scss) {
      const css = await fromScssToCss(`.${prefix}_${this.id} { ${scss} }`)
      this.propChanged('style', { css, scss })
    },
    propChanged(path, value) {
      this.updateOptions({
        id: this.id,
        path: `${this.currentView}.${path}`,
        value,
      })
    },
    propChangedForAllViews(path, value) {
      ;['lg', 'md', 'sm'].forEach(size => {
        this.updateOptions({
          id: this.id,
          path: `${size}.${path}`,
          value,
        })
      })
    },
  },
}
